import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  fr: {
    translation: {
      nav: {
        projects: 'Projets',
        teams: 'Teams', // Changed from Équipe to Teams as requested
        news: 'Actualités',
        contact: 'Contact',
      },
      hero: {
        viewProject: 'Voir le projet',
      },
      intro: {
        title: 'Studio',
        text: '', 
        discover: 'Découvrir l\'équipe', // Updated to match Teams page
      },
      projects: {
        title: 'Projets sélectionnés',
        all: 'Tous les projets',
      },
      expertise: {
        architecture: 'Conception architecturale',
        renovation: 'Rénovation & patrimoine',
        interior: 'Aménagement intérieur',
        artistic: 'Direction artistique',
        research: 'Recherche & prototypage',
      },
      news: {
        title: 'Actualités',
        all: 'Toutes les actualités',
      },
      contact: {
        invite: 'Discutons de votre projet.',
        cta: 'Nous contacter',
      },
      footer: {
        legal: 'Mentions légales',
        privacy: 'Politique de confidentialité',
      },
      teams: {
        title: 'Notre Équipe',
        intro: 'L\'interaction humaine façonne les espaces que nous concevons et notre façon de travailler.',
        searchPlaceholder: 'Rechercher par nom, rôle...',
        allLocations: 'Tous les lieux',
        allRoles: 'Tous les rôles',
        noResults: 'Aucun membre trouvé.',
      },
    },
  },
  en: {
    translation: {
      nav: {
        projects: 'Projects',
        teams: 'Teams',
        news: 'News',
        contact: 'Contact',
      },
      hero: {
        viewProject: 'View Project',
      },
      intro: {
        title: 'Studio',
        text: '', 
        discover: 'Discover the team', // Updated
      },
      projects: {
        title: 'Selected Projects',
        all: 'All projects',
      },
      expertise: {
        architecture: 'Architectural Design',
        renovation: 'Renovation & Heritage',
        interior: 'Interior Design',
        artistic: 'Art Direction',
        research: 'Research & Prototyping',
      },
      news: {
        title: 'News',
        all: 'All news',
      },
      contact: {
        invite: 'Let\'s discuss your project.',
        cta: 'Contact us',
      },
      footer: {
        legal: 'Legal Notice',
        privacy: 'Privacy Policy',
      },
      teams: {
        title: 'Our People',
        intro: 'Human interaction shapes the spaces we design and how we operate.',
        searchPlaceholder: 'Search by name, role...',
        allLocations: 'All Locations',
        allRoles: 'All Roles',
        noResults: 'No members found.',
      },
    },
  },
  zh: {
    translation: {
      nav: {
        projects: '项目',
        teams: '团队', // Keep Chinese as 团队 or change to Teams? User said "Change agence to teams". I'll keep 团队 for now unless they complain.
        news: '动态',
        contact: '联系',
      },
      hero: {
        viewProject: '查看项目',
      },
      intro: {
        title: '工作室',
        text: '', 
        discover: '了解团队', // Updated
      },
      projects: {
        title: '精选项目',
        all: '所有项目',
      },
      expertise: {
        architecture: '建筑设计',
        renovation: '改造与遗产',
        interior: '室内设计',
        artistic: '艺术指导',
        research: '研究与原型',
      },
      news: {
        title: '最新动态',
        all: '所有动态',
      },
      contact: {
        invite: '探讨您的项目。',
        cta: '联系我们',
      },
      footer: {
        legal: '法律声明',
        privacy: '隐私政策',
      },
      teams: {
        title: '团队成员',
        intro: '人与人的互动塑造了我们设计的空间以及我们的运作方式。',
        searchPlaceholder: '按姓名、职位搜索...',
        allLocations: '所有地点',
        allRoles: '所有职位',
        noResults: '未找到成员。',
      },
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'fr', // Default language
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
